import {
  ServicesToPatientList,
  ServicesToPatientStyle,
} from "./PatientGroupChatListItem.style";
import { ServicesToPatientText } from "../../../common/Common.style";
import React from "react";
import { IServicesToPatient } from "@home-health-notify/domain";

const ServicesToPatient = ({
  servicesToPatient,
}: {
  servicesToPatient: IServicesToPatient[];
}) => {
  return (
    <ServicesToPatientList data-testid="services-to-patient">
      {servicesToPatient &&
        servicesToPatient.map((service) => {
          return (
            <ServicesToPatientStyle key={service.id}>
              <ServicesToPatientText
                variant="subtitle2"
                status={service.status}
              >
                {service.shorthand}
              </ServicesToPatientText>
            </ServicesToPatientStyle>
          );
        })}
    </ServicesToPatientList>
  );
};

export default ServicesToPatient;
